export function addSign(num: number | string): string {
    let _num = num as number;
    if (typeof num === "string") {
        _num = parseFloat(num);
    }
    if (_num > 0) {
        return `+${num}`;
    } else {
        return `${num}`;
    }
}

export function formatNumber(number: any, decimal?: number, divisor?: number, unit?: string) {
    if (typeof number !== "number") return "--";
    let f = "";
    if (number < 0) {
        f = "-";
        number = -number;
    }
    if (divisor) {
        number = number / divisor;
        if (number < 0.01) {
            number = 0.01;
        }
    }
    // 将数字转换为字符串
    const numStr = number.toString();

    // 分割整数部分和小数部分
    const parts = numStr.split(".");
    const integerPart = parts[0];
    let decimalPart = parts[1] || "";

    // 对整数部分进行逗号分隔
    let formattedInteger = "";
    let i;
    let j = 1;
    for (i = integerPart.length - 1, j; i >= 0; i--, j++) {
        formattedInteger = integerPart[i] + formattedInteger;
        if (j > 0 && j % 3 === 0) {
            formattedInteger = "," + formattedInteger;
        }
    }
    if (formattedInteger[0] === ",") {
        formattedInteger = formattedInteger.slice(1);
    }
    // 如果不需要格式化小数部分，直接返回整数部分
    if (!decimal) {
        return formattedInteger;
    }
    // 拼接整数部分和小数部分
    decimalPart = parseFloat("0." + (decimalPart || 0))
        .toFixed(2)
        .slice(1);
    const suffix = unit || "";
    return f + formattedInteger + decimalPart + suffix;
}
// 数字整数部分千分位分割
export function formatNumberWithThousands(number: any) {
    if (typeof number !== "number") return "--";
    // 转为字符串，防止传入数字时丢失精度
    let str = String(number).trim();

    // 分离整数部分和小数部分
    const parts = str.split(".");
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? "." + parts[1] : "";

    // 对整数部分添加千分位逗号
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // 返回拼接结果
    return integerPart + decimalPart;
}
export function numberCalculate(num1: number = 0, num2: number = 0, operator: "+" | "-" | "*" | "/", decimal?: number) {
    const num1S: string = num1.toString() || "0";
    const num2S: string = num2.toString() || "0";
    const maxLen: number = Math.max(num1S.split(".")[1]?.length || 0, num2S.split(".")[1]?.length || 0);
    const step: number = Math.pow(10, maxLen);
    let result: number | string = 0;
    switch (operator) {
        case "+":
            result = (fn(num1, step) + fn(num2, step)) / step;
            break;
        case "-":
            result = (fn(num1, step) - fn(num2, step)) / step;
            break;
        case "*":
            result = (fn(num1, step) * fn(num2, step)) / (step * step);
            break;
        case "/":
            result = fn(num1, step) / fn(num2, step);
            break;
        default:
            break;
    }
    if (decimal) {
        return formatNumber(result, 2);
    }
    return result ? Number(result) : result;

    function fn(num: number, step: number): number {
        const numS: string = num.toString();
        const arr: string[] = numS.split(".");
        let result: number = Number(arr[0]) * step;
        if (arr[1]) {
            result += (Number(arr[1]) * step) / Math.pow(10, arr[1].length);
        }
        return result;
    }
}

//转千分位
export const toThousand = (num: number | string) => {
    if (!num) {
        return num;
    }
    const r = typeof num === "number" ? num.toString() : num;
    return r.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
